import { IconNamesProps } from "./Icon"

const emotionNormal = ({ color = "#0E0E0E", ...rest }: IconNamesProps) => (
    <svg width={26} height={26} viewBox="0 0 26 26" fill="none" {...rest}>
        <g clipPath="url(#clip0_1_17)">
            <g>
                <path
                    d="M13 23.8333C7.01675 23.8333 2.16667 18.9832 2.16667 13C2.16667 7.01675 7.01675 2.16667 13 2.16667C18.9832 2.16667 23.8333 7.01675 23.8333 13C23.8333 18.9832 18.9832 23.8333 13 23.8333ZM8.66667 15.1667V17.3333H17.3333V15.1667H8.66667ZM8.66667 11.9167C9.09764 11.9167 9.51097 11.7455 9.81572 11.4407C10.1205 11.136 10.2917 10.7226 10.2917 10.2917C10.2917 9.86069 10.1205 9.44736 9.81572 9.14262C9.51097 8.83787 9.09764 8.66667 8.66667 8.66667C8.23569 8.66667 7.82236 8.83787 7.51762 9.14262C7.21287 9.44736 7.04167 9.86069 7.04167 10.2917C7.04167 10.7226 7.21287 11.136 7.51762 11.4407C7.82236 11.7455 8.23569 11.9167 8.66667 11.9167V11.9167ZM17.3333 11.9167C17.7643 11.9167 18.1776 11.7455 18.4824 11.4407C18.7871 11.136 18.9583 10.7226 18.9583 10.2917C18.9583 9.86069 18.7871 9.44736 18.4824 9.14262C18.1776 8.83787 17.7643 8.66667 17.3333 8.66667C16.9024 8.66667 16.489 8.83787 16.1843 9.14262C15.8795 9.44736 15.7083 9.86069 15.7083 10.2917C15.7083 10.7226 15.8795 11.136 16.1843 11.4407C16.489 11.7455 16.9024 11.9167 17.3333 11.9167Z"
                    fill={color}
                />
            </g>
        </g>
        <defs>
            <clipPath>
                <rect width={26} height={26} fill="white" />
            </clipPath>
        </defs>
    </svg>
)

export default emotionNormal
